import { ReferenceRangeDisplay } from "@/components/ReferenceRangeDisplay/ReferenceRangeDisplay";
import { BodyText } from "@/components/ui/Text";
import {
  HistoryModal,
  type HistoryRow,
} from "@/features/Patient/MedicalRecords/components/HistoryModal";
import { formatDate } from "@/lib/time";
import * as React from "react";
import { type BMIRecord, useBmiHistory } from "../network/useBmiHistory";

interface BmiHistoryModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  patientId: string;
}

function renderBmiResult(item: BMIRecord): React.ReactNode {
  const bmiString = `${item.bmi}`;
  const { criticality, referenceRanges } = item;

  return (
    <BodyText size="sm">
      <ReferenceRangeDisplay
        criticality={criticality ?? null}
        data={bmiString}
        referenceRanges={referenceRanges ?? null}
        tooltipFallback=""
        tooltipContentClassName="z-30"
      />
    </BodyText>
  );
}

export const BmiHistoryModal = ({
  open,
  onOpenChange,
  patientId,
}: BmiHistoryModalProps) => {
  const { data, isLoading, isError } = useBmiHistory({
    patientId,
    enabled: open,
  });

  const rows: HistoryRow[] = React.useMemo(() => {
    if (!data) return [];
    const items = data?.bmiHistory ?? [];
    return items.map((item: BMIRecord) => ({
      date: formatDate(item.effectiveDate),
      result: renderBmiResult(item),
    }));
  }, [data]);

  return (
    <HistoryModal
      emptyMessage="No BMI history found."
      title="BMI"
      rows={rows}
      onOpenChange={onOpenChange}
      open={open}
      isLoading={isLoading}
      isError={isError}
    />
  );
};
